// Cameroon Pidgin. Keys are the English source strings; {name} marks a value filled in afterwards.
export const PCM = {
  'Welcome to Bamenda': 'Welcome for Bamenda',
  'The real Bamenda, Buea and Limbe, alive with half a million people. Before you walk in, one question.': 'Di real Bamenda, Buea and Limbe, weh half million people dey inside. Before you enter, one question.',
  'Your year of birth': 'Di year weh dem born you',
  'For example 1998': 'Like 1998',
  'Abakwa is for adults. Asked once; only whether you are eighteen is kept, never the year.': 'Abakwa na for big people. We ask only one time; we keep only say you don reach eighteen, no be di year.',
  'The town opens at eighteen. Come back then.': 'Di town open for eighteen. Come back dat time.',
  Continue: 'Continue',
  'The rules of the town': 'Di rules for di town',
  'Who are you in this town?': 'Na who you be for dis town?',
  'A name people will call across the street, and the look you walk in with.': 'Di name weh people go call you for road, and how you look when you enter.',
  'Your name': 'Your name',
  'For example Che, Bih or Ngwa': 'Like Che, Bih or Ngwa',
  'Type a name first, so people know what to call you.': 'First write name, make people sabi how for call you.',
  Skin: 'Skin',
  Shirt: 'Shirt',
  Trousers: 'Trouser',
  'Where you start': 'Where you go start',
  'At my house': 'For my house',
  'You wake up at your own door in your quarter.': 'You go wake up for your own door for your quarter.',
  'Where I really am': 'Where I really dey',
  'Asks the browser for your location; works inside the North West or South West maps.': 'E go ask your browser where you dey; e work only inside North West or South West map.',
  'Enter the town': 'Enter di town',
  'By entering you keep to ': 'If you enter, you go follow ',
  ': adults only, no contacts or slurs in the chat.': ': only big people, no number, no link, no bad word for chat.',
  Language: 'Language',
  Age: 'Age',
  You: 'You',
  Childhood: 'Pikin time',
  Arrival: 'Arrival',
  Back: 'Back',
  'So you arrive in town': 'So you don reach town',
  'A bushfaller family sends money home every Saturday.': 'Bushfaller family dey send money every Saturday.',
  'A quarter pikin with two legs and a seat in the njangi.': 'Quarter pikin with two leg and one seat for njangi.',
  'Live it again': 'Live am again',
  Traits: 'Your way',
  Skills: 'Skills',
  Dream: 'Dream',
  Home: 'House',
  'In your pocket': 'For your pocket',
  'None yet; pick two on the phone': 'None yet; pick two for phone',
  'None yet': 'None yet',
  'Not yet': 'Not yet',
  'scene {n} of {total}': 'scene {n} for {total}',
  'You were born in': 'Dem born you for',
  'The year does not matter here. The place does.': 'Di year no matter here. Di place matter.',
  'Ntarikon, in a single room by the stream. Your mother sold garri at Food Market.': 'Ntarikon, for one single room near di stream. Your mami bin sell garri for Food Market.',
  "Nkwen, in your father's compound behind the Nkwen market. Chickens, a maize farm, cousins everywhere.": 'Nkwen, for your papa him compound behind Nkwen market. Fowl, corn farm, cousin everywhere.',
  'Up Station, in a flat with a view down over the whole city. Your father was a civil servant.': 'Up Station, for flat weh you fit see di whole town. Your papa bin be civil servant.',
  "A village at Bafut. Your mother's farm fed you; the Fon's palace was a walk away.": 'One village for Bafut. Your mami farm bin feed you; di Fon palace bin dey near.',
  'Yaoundé, to parents who later left for Germany and sent you back to your grandmother in Bamenda.': 'Yaoundé, for parents weh later go Germany and send you back for your grandmami for Bamenda.',
  'At six': 'When you be six',
  'Every child in Bamenda is raised by more than two people.': 'For Bamenda, na plenty people dey raise one pikin.',
  'You were sent to the village to your grandmother. Water from the stream, church every Sunday, stories at night.': 'Dem send you for village for your grandmami. Water from stream, church every Sunday, story for night.',
  'You stayed home and ran the quarter with the other children. Football in the dust until the light went.': 'You stay for house and run di quarter with di other pikin dem. Football for dust until light go.',
  'Your father went to Douala to find work and came home at Christmas. You learned early how money moves.': 'Your papa go Douala for find work and come back for Christmas. You learn early how money dey waka.',
  'You lived with your aunt who ran a hair salon on Commercial Avenue. You could braid before you could spell.': 'You stay with your aunty weh get salon for Commercial Avenue. You sabi plait before you sabi spell.',
  'Primary school': 'Primary school',
  'Government School, "free", with PTA fees of 15,000 FCFA a year that were not always there.': 'Government School, "free", with PTA fee of 15,000 FCFA for year weh no always dey.',
  'The fees were paid every September, somehow. You never missed a term.': 'Dem pay di fee every September, anyhow. You never miss one term.',
  'Some years the fees came late and you stayed home a term. You caught up; you also learned to sell.': 'Some year di fee come late and you stay house one term. You catch up; you also learn for sell.',
  'You sold puff-puff from a tray after school to pay your own fees. Everybody in the quarter knew you.': 'You sell puff-puff for tray after school for pay your own fee. Everybody for quarter sabi you.',
  'The crisis closed the school for two years. You learned at home from an uncle and from the radio.': 'Di crisis close school for two year. You learn for house from one uncle and from radio.',
  'The GCE year': 'Di GCE year',
  'Form Five. Everybody tells you this exam decides your life. It decides something.': 'Form Five. Everybody tell you say dis exam go decide your life. E decide something.',
  'You read under the kerosene lamp until the neighbours complained. Eight papers passed.': 'You read under kerosene lamp until neighbour complain. Eight paper pass.',
  'You played for the quarter team and passed four papers. Nobody in Nkwen forgets the final.': 'You play for quarter team and pass four paper. Nobody for Nkwen forget dat final.',
  'You fixed phones at the motor park on weekends and passed five. The park chairman knows your name.': 'You fix phone for motor park weekend and pass five. Di park chairman sabi your name.',
  'You led the church choir and passed six. The whole quarter heard your voice.': 'You lead church choir and pass six. Di whole quarter hear your voice.',
  'After Form Five': 'After Form Five',
  'The family sat down. Fees, or a trade, or the road.': 'Family siddon. Fee, or trade, or road.',
  'The University of Bamenda at Bambili: 50,000 a year, a hostel bed, two-minute noodles.': 'University of Bamenda for Bambili: 50,000 for year, hostel bed, indomie.',
  'Apprentice to a mechanic at Mile 4. Three years of grease and no pay, then your own tools.': 'Apprentice for mechanic for Mile 4. Three year grease and no pay, then your own tool.',
  'Apprentice at a salon on Commercial Avenue. You can do wigs, braids and gossip.': 'Apprentice for salon for Commercial Avenue. You fit do wig, braids and gist.',
  'The motor park. Loading, calling passengers, counting coins. Nothing in Bamenda moves without you.': 'Motor park. Loading, calling passenger, counting coin. Nothing for Bamenda dey move without you.',
  "Your mother's kitchen became a restaurant and you were the cook. Achu on Tuesdays, pepper soup at night.": 'Your mami kitchen turn restaurant and you be di cook. Achu for Tuesday, pepper soup for night.',
  'The year you turned twenty': 'Di year weh you turn twenty',
  'Something happens to every family.': 'Something dey happen for every family.',
  "Your father died. The death celebration took the family's savings and a loan; the compound went to his successor, your elder brother.": 'Your papa die. Di cry-die take family savings and loan; di compound go for him successor, your big broda.',
  'Your mother fell ill and you carried the hospital bills for a year. She is better now.': 'Your mami fall sick and you carry hospital bill for one year. She dey better now.',
  "Your mother's njangi came through and she put the pot in your hand: start something.": 'Your mami njangi come and she put di pot for your hand: start something.',
  'Nothing. A quiet year, rain on the zinc, school fees paid. You left for town with a bag and a bucket.': 'Nothing. Quiet year, rain for zinc, school fee pay. You go town with one bag and one bucket.',
  Hunger: 'Hunger',
  Energy: 'Power',
  Fun: 'Enjoyment',
  Social: 'People',
  Hygiene: 'Clean',
  Bladder: 'Toilet',
  'You dey tire: chop or sleep': 'You dey tire: chop or sleep',
  'All controls': 'All di controls',
  Controls: 'Controls',
  Close: 'Close',
  Dismiss: 'Close',
  'Greet the {who}': 'Greet di {who}',
  Greet: 'Greet',
  'Work: {place}': 'Work: {place}',
  'Drive {what}': 'Drive {what}',
  'Find passenger': 'Find passenger',
  'Give up ride': 'Leave di ride',
  'On foot': 'For leg',
  'Stop building': 'Stop building',
  'Coach to {to}': 'Bus for {to}',
  'Chop {food} · {price}': 'Chop {food} · {price}',
  'At home': 'For house',
  'Land here': 'Land here',
  walk: 'waka',
  run: 'run',
  build: 'build',
  town: 'town',
  news: 'news',
  map: 'map',
  mission: 'mission',
  'my places': 'my place dem',
  chat: 'chat',
  drone: 'drone',
  phone: 'phone',
  'back on foot': 'for leg',
  'stop building': 'stop building',
  'give up the ride': 'leave di ride',
  'find a passenger': 'find passenger',
  'get out': 'comot',
  Jump: 'Jump',
  Phone: 'Phone',
  Map: 'Map',
  Chat: 'Chat',
  Me: 'Me',
  Jobs: 'Work',
  Do: 'Do',
  Market: 'Market',
  Money: 'Money',
  Family: 'Family',
  Council: 'Council',
  Settings: 'Settings',
  Music: 'Music',
  Notifications: 'News for you',
  Apps: 'Apps',
  'Nothing new. Greet people and the news of them comes here.': 'Nothing new. Greet people and their news go come here.',
  'Pick your two traits and a dream in Me.': 'Pick your two way and one dream for Me.',
  'Say who you are in Family, once.': 'Talk who you be for Family, one time.',
  'No job yet. Apply in Jobs, then work a shift a day.': 'No work yet. Apply for Work, then do one shift a day.',
  '{need} is low. See Do.': '{need} don low. Check Do.',
  'Back to the apps': 'Back for apps',
  'Close the phone': 'Close phone',
  'The phone needs the server. It is not connected.': 'Phone need server. E no connect.',
  Needs: 'Wetin you need',
  'Choose two traits, once': 'Pick two way, one time',
  'They shape how fast you learn and what wears you down.': 'Dem decide how fast you learn and wetin dey tire you.',
  'Lifetime dream': 'Dream for life',
  'Keep these': 'Keep dem',
  'Who you are': 'Who you be',
  'People you know: {n}': 'People weh you sabi: {n}',
  'Greet people (E) and they remember you; you hear when life happens to them.': 'Greet people (E) and dem go remember you; you go hear when something happen for dem.',
  'You are at home in {place}.': 'You dey for house for {place}.',
  'Home is in {place}. Things at home need you there.': 'Your house dey for {place}. House thing need you for there.',
  'At a {place}': 'For {place}',
  'motor park': 'motor park',
  Free: 'Free',
  'Go there first': 'First go there',
  'Ready in {n} min': 'Ready for {n} min',
  'a week, taken every Saturday': 'for week, dem take am every Saturday',
  'Your things': 'Your things',
  'Nothing yet. The Market sells things for the home.': 'Nothing yet. Market dey sell house things.',
  'Taxi home to {place}': 'Taxi go house for {place}',
  'The fare of the distance.': 'Di fare for di distance.',
  'Move house': 'Change house',
  'Three weeks of the new rent up front.': 'Three week rent for front.',
  unfurnished: 'no furniture',
  Yours: 'Your own',
  Move: 'Move',
  'Move to a {home} in {where}?': 'Move go {home} for {where}?',
  'Three weeks of rent up front; your things come with you.': 'Three week rent for front; your things go follow you.',
  'a shift': 'for shift',
  '{n} shift': '{n} shift',
  '{n} shifts': '{n} shift',
  'performance {n}%': 'performance {n}%',
  'Next level needs {skill} {need} (yours: {have}).': 'Next level need {skill} {need} (your own: {have}).',
  'Towards the next level': 'Towards next level',
  'Go there in the shift hours and press E. One shift a day; late costs performance.': 'Go there for shift time and press E. One shift a day; late go cost performance.',
  'Leave this job': 'Leave dis work',
  'Leave {job}?': 'Leave {job}?',
  'You can apply again later; the level is lost.': 'You fit apply again later; di level go lost.',
  Leave: 'Leave',
  'Other work in town': 'Other work for town',
  'Work in town': 'Work for town',
  'Apply, then go there in the shift hours and press E. The nearest workplace of the kind to your home.': 'Apply, then go there for shift time and press E. Di workplace weh near your house.',
  Apply: 'Apply',
  Vehicles: 'Motor dem',
  'Yours waits outside your home each morning.': 'Your own dey wait outside your house every morning.',
  Buy: 'Buy',
  'Buy a {thing}?': 'Buy {thing}?',
  'Buy {thing}?': 'Buy {thing}?',
  Businesses: 'Business',
  'They pay every midnight without a shift; some days go badly.': 'Dem pay every midnight without shift; some day go bad.',
  'a day': 'a day',
  weekends: 'weekend',
  'earned {n}': 'don bring {n}',
  Land: 'Land',
  'Grows in value every week; the quarter head takes a levy when you buy.': 'E dey grow every week; quarter head take levy when you buy.',
  'Worth {n} now': 'Worth {n} now',
  Sell: 'Sell',
  'Sell {thing}?': 'Sell {thing}?',
  'The buyer pays {n}.': 'Di buyer pay {n}.',
  'Grows {n}% a week': 'Grow {n}% a week',
  "With the quarter head's levy.": 'With quarter head levy.',
  'For the home': 'For house',
  'This week': 'Dis week',
  'Rent on Saturday': 'Rent for Saturday',
  'From your people': 'From your people',
  'Every Saturday': 'Every Saturday',
  Njangi: 'Njangi',
  'The pot of 20,000 comes round in turn': 'Di pot of 20,000 dey turn',
  Owed: 'Debt',
  'Paid from the next earnings': 'Dem go take am from next money',
  'Loan left': 'Loan remain',
  '{n} every Saturday': '{n} every Saturday',
  'Borrow {n}': 'Borrow {n}',
  'Repay {weekly} every Saturday for {weeks} weeks ({total} in all)': 'Pay back {weekly} every Saturday for {weeks} week ({total} all)',
  Take: 'Take',
  'Take {n}?': 'Take {n}?',
  '{weekly} leaves every Saturday for {weeks} weeks. Miss it and your njangi seat goes.': '{weekly} go comot every Saturday for {weeks} week. Miss am and your njangi seat go.',
  '{n} to repay': '{n} for pay back',
  'Take the loan': 'Take di loan',
  'Send money': 'Send money',
  '{fee}% fee, at most {cap} FCFA; {daily} a day.': '{fee}% fee, no pass {cap} FCFA; {daily} a day.',
  'Player name': 'Player name',
  Amount: 'How much',
  'Amount in FCFA': 'How much for FCFA',
  To: 'To',
  Send: 'Send',
  'A name and at least 100 FCFA.': 'Name and at least 100 FCFA.',
  'Send {n} to {who}?': 'Send {n} for {who}?',
  'The fee is {n}.': 'Fee na {n}.',
  'Asking the family…': 'We dey ask family…',
  'Who are you?': 'Who you be?',
  'Said once. It decides whom you can marry and who inherits.': 'You talk am one time. E decide who you fit marry and who go inherit.',
  'A man': 'Man',
  'A woman': 'Woman',
  'Lived here {n} real day': 'You don dey here {n} real day',
  'Lived here {n} real days': 'You don dey here {n} real day',
  'You do not age; your children do, a year a day, and the town with them.': 'You no dey old; your pikin dem dey old, one year a day, and di town with dem.',
  Mother: 'Mami',
  Father: 'Papa',
  Unknown: 'Nobody sabi',
  late: 'late',
  'Brothers and sisters': 'Broda and sista dem',
  Wife: 'Wife',
  Husband: 'Husband',
  None: 'None',
  Separate: 'Separate',
  'Separate from {who}?': 'Separate from {who}?',
  'She goes back to her people; the children mostly stay.': 'She go back for her people; di pikin dem mostly stay.',
  'Second wife': 'Second wife',
  Heir: 'Successor',
  'Not named': 'Never name',
  'School fees': 'School fee',
  'Your people': 'Your people',
  'Children ({n})': 'Pikin dem ({n})',
  'Children come in their own time.': 'Pikin dey come for their own time.',
  'Marry first; or take in a kin child the town sends your way.': 'First marry; or take family pikin weh town send for you.',
  'taken in': 'taken in',
  died: 'don die',
  'Name heir': 'Name successor',
  'Hand over': 'Hand over',
  'Go on as {heir}: the house and the name pass whole, the money less {cost} for the celebration, skills capped at level 3, the job given up.': 'Continue as {heir}: house and name pass full, money minus {cost} for cry-die, skill stop for level 3, work go.',
  'Hand over to {heir}': 'Hand over for {heir}',
  'Wait: {heir} is {age}': 'Wait: {heir} be {age}',
  'Wait: live a real week first': 'Wait: first live one real week',
  'Hand over to {heir}?': 'Hand over for {heir}?',
  'Your character becomes a townsperson and you go on as the heir.': 'Your character go turn townsperson and you go continue as successor.',
  'A second wife': 'Second wife',
  Marry: 'Marry',
  '{price}: the bride price list and the wedding. Only people you have greeted.': '{price}: bride price list and wedding. Only people weh you don greet.',
  'Nobody yet: greet single people your age (E) and come back.': 'Nobody yet: greet single people for your age (E) and come back.',
  'met at {where}': 'meet for {where}',
  Propose: 'Propose',
  'Propose to {who}?': 'Propose for {who}?',
  'The bride price list and the wedding, paid to her people.': 'Bride price list and wedding, pay for her people.',
  'Asking the council…': 'We dey ask council…',
  Mayor: 'Mayor',
  'No mayor yet': 'No mayor yet',
  'The first election is running.': 'First election dey run.',
  'Until {date}.': 'Until {date}.',
  'Election closes {date}': 'Election close {date}',
  'Votes are cast at {place}; one each.': 'Vote dey happen for {place}; one each.',
  'the council': 'di council',
  '{n} vote': '{n} vote',
  '{n} votes': '{n} vote',
  Vote: 'Vote',
  'You have voted': 'You don vote',
  '(you)': '(you)',
  'Stand for mayor': 'Stand for mayor',
  'Pick the policy you would hold for a term.': 'Pick di policy weh you go hold for one term.',
  Stand: 'Stand',
  'Stand on "{policy}"?': 'Stand with "{policy}"?',
  'Your name goes on the ballot until the election closes.': 'Your name go dey for ballot until election close.',
  'Achievements ({n} of {total})': 'Achievement ({n} for {total})',
  'Day and night': 'Day and night',
  'Real Bamenda time': 'Real Bamenda time',
  'A whole day every two hours': 'One full day every two hour',
  Faster: 'Faster',
  'Real time': 'Real time',
  Sound: 'Sound',
  On: 'On',
  Off: 'Off',
  'Turn on': 'Put am on',
  'Turn off': 'Put am off',
  Quality: 'Quality',
  'changes on reload': 'e change when you reload',
  Change: 'Change',
  'Name and look': 'Name and look',
  'Back to the first screen': 'Back for first screen',
  'English, French or Pidgin': 'English, French or Pidgin',
  About: 'About',
  'In debt': 'For debt',
  'Getting by': 'Dey manage',
  Comfortable: 'Dey okay',
  'Well off': 'Get money',
  '{role}, {age} years old': '{role}, {age} year',
  '{role}, died aged {age}': '{role}, die for {age} year',
  'Lives in': 'Dey live for',
  Household: 'House people',
  'Lives alone': 'Live alone',
  '{n} people': '{n} people',
  Standing: 'Standing',
  'Works at': 'Work for',
  'Your neighbour in {where}.': 'Your neighbour for {where}.',
  'Your family.': 'Your family.',
  'You greeted them {n} time, last at {where} on {date}.': 'You greet am {n} time, last for {where} on {date}.',
  'You greeted them {n} times, last at {where} on {date}.': 'You greet am {n} time, last for {where} on {date}.',
  Divorced: 'Divorced',
  Widowed: 'Widow',
  'Raised by': 'Who raise am',
  'kin, after losing the parents': 'family, after parents die',
  Nature: 'Nature',
  Health: 'Health',
  Mind: 'Mind',
  Charm: 'Charm',
  'Has not been well in the mind lately; the family carries it.': 'Him mind no dey well dis days; family dey carry am.',
  'In need of care; the family looks after them.': 'E need care; family dey look after am.',
  'Known to the gendarmes.': 'Gendarme dem sabi am.',
  People: 'People',
  Homes: 'House dem',
  '{n} empty': '{n} empty',
  'Young families housed': 'Young family weh get house',
  'Houses families built': 'House weh family build',
  'Land and animals': 'Land and animal',
  'Food in the market': 'Food for market',
  dear: 'cost',
  cheap: 'cheap',
  normal: 'normal',
  Grass: 'Grass',
  Goats: 'Goat',
  Fowls: 'Fowl',
  Cattle: 'Cow',
  'Bush animals': 'Bush meat',
  'Hawks, snakes, civets': 'Hawk, snake, civet',
  'The whole region, year {n}': 'Di whole region, year {n}',
  'Births so far': 'Born so far',
  'Deaths so far': 'Die so far',
  'Left for the cities': 'Go for big town',
  'Town news': 'Town news',
  'Nothing of note has happened yet.': 'Nothing big don happen yet.',
  'Year {n}': 'Year {n}',
  News: 'News',
  'Real headlines from Cameroonian news sites': 'Real headline from Cameroon news site dem',
  'Notices from this server': 'Notice from dis server',
  Headlines: 'Headline',
  'No headlines could be fetched just now. They are checked every half hour.': 'No headline fit come now. We check every half hour.',
  'My places': 'My place dem',
  "Only you see these, unless you give someone a place's code": 'Only you dey see dem, unless you give person di place code',
  'Name the spot you are standing on': 'Name di place weh you stand',
  'Name for this place': 'Name for dis place',
  Save: 'Save',
  'from {who}': 'from {who}',
  'code to share: {code}': 'code for share: {code}',
  Way: 'Road',
  Remove: 'Remove',
  'Nothing saved yet. Stand at your house, name it above and press Save.': 'Nothing save yet. Stand for your house, name am for up and press Save.',
  "Friends' places": 'Friend dem place',
  "A friend's code": 'Friend code',
  "Code of a friend's place": 'Code for friend place',
  Add: 'Add',
  'Chat message': 'Chat message',
  'Say something to everyone': 'Talk something for everybody',
  'Mission hidden. Press M to show it again.': 'Mission hide. Press M make e show again.',
  'Sound on': 'Sound on',
  'Sound off': 'Sound off',
  'Build mode off': 'Build mode off',
  'You slept well.': 'You sleep well.',
  'Done.': 'Done.',
  'Done: {title}. You earned {n} FCFA.': 'Done: {title}. You get {n} FCFA.',
  'Mission passed': 'Mission pass',
  'Lost the server. The town is quiet until it returns.': 'Server don go. Town go quiet until e come back.',
  'No light in {place}: a power cut': 'Light don go for {place}',
  'The light is back in {place}': 'Light don come back for {place}',
  'You gave up the ride': 'You leave di ride',
  'Fuel is short today: there are queues at the stations': 'Fuel short today: line dey for station',
  'Fuel has come: the queues at the stations are gone': 'Fuel don come: line for station don go',
  'You show your ID card and are waved on': 'You show your ID card and dem wave you pass',
  'A control post: slow down and stop': 'Control post: slow down and stop',
  'Saturday: {parts}. You have {money} FCFA.': 'Saturday: {parts}. You get {money} FCFA.',
  'landlord took {n}': 'landlord take {n}',
  'you could not pay the rent, you owe {n}': 'you no fit pay rent, you owe {n}',
  'your people sent {n}': 'your people send {n}',
  'njangi took {n}': 'njangi take {n}',
  'na your turn: the njangi pot of {n} is yours': 'na your turn: njangi pot of {n} na your own',
  'the microfinance took {n}': 'microfinance take {n}',
  'you defaulted on the loan: your njangi seat is gone and the rest is debt': 'you no pay loan: your njangi seat don go and di rest na debt',
  'You chop {food}.': 'You chop {food}.',
  'You married {who}. The bride price and the wedding came to {n} FCFA.': 'You marry {who}. Bride price and wedding reach {n} FCFA.',
  '{who} has gone back to her people.': '{who} don go back for her people.',
  'You go on as {who}. The celebration cost {n} FCFA; the house and the name are yours.': 'You continue as {who}. Cry-die cost {n} FCFA; house and name na your own.',
  'The taxi dropped you at {place}. Fare {n} FCFA.': 'Taxi drop you for {place}. Fare {n} FCFA.',
  'Achievement: {name}. {n} FCFA.': 'Achievement: {name}. {n} FCFA.',
  'News: {text}': 'News: {text}',
  'You voted for {who}.': 'You vote for {who}.',
  Town: 'Town',
  Village: 'Village',
  Quarter: 'Quarter',
  School: 'School',
  College: 'College',
  University: 'University',
  Hospital: 'Hospital',
  Clinic: 'Clinic',
  'Place of worship': 'Church / mosque',
  Bank: 'Bank',
  'Fuel station': 'Fuel station',
  'Motor park': 'Motor park',
  Hotel: 'Hotel',
  Airport: 'Airport',
  Stadium: 'Stadium',
  'Place to see': 'Place for see',
  Police: 'Police',
  Food: 'Chop',
  'Find a place': 'Find place',
  'Places found': 'Place weh we find',
  'Close the map': 'Close map',
  'Town hall': 'Council',
  Pharmacy: 'Pharmacy',
  Shop: 'Shop',
  Legend: 'Wetin di icon dem mean',
  'Go here': 'Go here',
  'Clear the route': 'Clear di road',
  'Route: {dist} to {place}': 'Road: {dist} go {place}',
  'You have arrived at {place}': 'You don reach {place}',
  Cooking: 'Cooking',
  Charisma: 'Mouth',
  Fitness: 'Body',
  Coding: 'Computer',
  Dance: 'Dance',
  Comedy: 'Comedy',
  Photography: 'Photo',
  Hustle: 'Hustle',
  Hustler: 'Hustler',
  'Hustle grows half again as fast.': 'Hustle dey grow one and half time fast.',
  Foodie: 'Chop man',
  'Cooking grows 1.6x; food fills you more.': 'Cooking grow 1.6 time; food full you more.',
  'Tech Bro / Sis': 'Tech Bro / Sis',
  'Coding grows 1.6x.': 'Computer grow 1.6 time.',
  Musical: 'Music person',
  'Music grows 1.6x.': 'Music grow 1.6 time.',
  'Smooth Talker': 'Sweet mouth',
  'Charisma grows half again as fast.': 'Mouth dey grow one and half time fast.',
  'Gym Rat': 'Gym person',
  'Fitness grows 1.6x.': 'Body grow 1.6 time.',
  'Owambe Spirit': 'Owambe spirit',
  'Fun drains slower, social fills faster.': 'Enjoyment no dey finish quick, people full fast.',
  'Lazy Bone': 'Lazy bone',
  'Energy drains slower; work performance -10%.': 'Power no dey finish quick; work performance -10%.',
  'Clean Pikin': 'Clean pikin',
  'Hygiene drains slower.': 'Clean no dey finish quick.',
  'Night Crawler': 'Night crawler',
  'Night shifts pay 10% more.': 'Night shift pay 10% more.',
  'Hostel bed': 'Hostel bed',
  'Single room': 'Single room',
  'Self-contain': 'Self-contain',
  'Mini-flat': 'Mini-flat',
  Flat: 'Flat',
  Duplex: 'Duplex',
  'Compound with a view': 'Compound with view',
  'Bucket and bowl': 'Bucket and bowl',
  'Water drum': 'Water drum',
  'Foam mattress': 'Foam mattress',
  Blanket: 'Blanket',
  'Kerosene stove': 'Kerosene stove',
  'Gas cooker': 'Gas cooker',
  'Cooler box': 'Cooler',
  Fridge: 'Fridge',
  'Standing fan': 'Standing fan',
  Radio: 'Radio',
  Television: 'TV',
  Decoder: 'Decoder',
  'Games console': 'Game console',
  'Split air conditioner': 'AC',
  'Rechargeable lamp': 'Rechargeable lamp',
  'Solar panel and inverter': 'Solar panel and inverter',
  'A local dog': 'Local dog',
  Sleep: 'Sleep',
  Nap: 'Small sleep',
  Bathe: 'Baff',
  Toilet: 'Toilet',
  'Cook a plate': 'Cook plate',
  'Relax at home': 'Rest for house',
  'A beer': 'One beer',
  'Toilet (50 FCFA)': 'Toilet (50 FCFA)',
  'Motor-park toilet': 'Motor park toilet',
  'Watch the match': 'Watch match',
  'Kick a ball': 'Play ball',
  'Attend the service': 'Go church',
  'Gist with the traders': 'Gist with trader dem',
  'Watch a film': 'Watch film',
  'Read and practise': 'Read and practise',
  Banking: 'Bank work',
  Nursing: 'Nurse work',
  Teaching: 'Teaching',
  Lecturing: 'Lecturing',
  'Council clerk': 'Council clerk',
  'Radio presenter': 'Radio presenter',
  'Market trading': 'Market trading',
  Shopkeeping: 'Shop keeping',
  Hairdressing: 'Hair dressing',
  'Hotel work': 'Hotel work',
  Football: 'Football',
  Mechanic: 'Mechanic',
  Tech: 'Tech',
  'Content creator': 'Content creator',
  'Coach loader': 'Loader',
  'Church work': 'Church work',
  'Call box and recharge kiosk': 'Call box and recharge',
  'Provision store': 'Provision store',
  'Barbing salon': 'Barbing salon',
  Buka: 'Buka',
  'Car wash': 'Car wash',
  'Event hall': 'Event hall',
  '5% of a hotel': '5% of hotel',
  'Okada (used)': 'Okada (second hand)',
  'Toyota Corolla (used)': 'Toyota Corolla (second hand)',
  'Corolla taxi, licensed': 'Corolla taxi, with licence',
  'Pickup (used)': 'Pickup (second hand)',
  'Hiace minibus': 'Hiace',
  'First pay': 'First pay',
  'Steady hand': 'Steady hand',
  'First passenger': 'First passenger',
  'Road warrior': 'Road warrior',
  'Everybody knows you': 'Everybody sabi you',
  'Small business': 'Small business',
  Millionaire: 'Millionaire',
  'Big house': 'Big house',
  'puff-puff': 'puff-puff',
  bread: 'bread',
  'roasted plantain': 'roast plantain',
  'a plate of fufu and njama njama': 'fufu and njama njama',
  'above sea level': 'above sea',
  'All {n} missions done': 'All {n} mission don finish',
  'The town is yours to build': 'Di town na your own for build',
  'Keep working, keep building, and watch the families you housed grow.': 'Continue work, continue build, and watch di family dem weh you house grow.',
  'Mission {n} of {total} · {reward} FCFA': 'Mission {n} for {total} · {reward} FCFA',
  'Step {n} of {total}': 'Step {n} for {total}',
  level: 'level',
  wk: 'wk',
  'turn left in {n} m': 'turn left for {n} m',
  'turn right in {n} m': 'turn right for {n} m',
  'you are there': 'you don reach',
  'No road leads there; follow the marker': 'No road dey go there; follow di mark',
  'the place you marked': 'di place weh you mark',
  Place: 'Place',
  'Your route': 'Your road',
  'Where you are going': 'Where you dey go',
  'Drag to move · scroll or pinch to zoom · tap a place to go there': 'Drag for move · scroll or pinch for zoom · touch place for go there',
  'On the way to {place}': 'We dey go {place}',
  Next: 'Next one',
  'Paste a YouTube link': 'Paste YouTube link',
  'YouTube link': 'YouTube link',
  Play: 'Play',
  'Search on YouTube': 'Search for YouTube',
  'Play a song or a playlist': 'Play song or playlist',
  'Any video or playlist link. A video whose label has switched off embedding says so; pick another.': 'Any video or playlist link. If di label block am, di video go talk; pick another one.',
  Stations: 'Stations',
  'The owner can list playlists in public/music.json; they appear here for everyone.': 'Di owner fit put playlist for public/music.json; dem go show here for everybody.',
  Recent: 'Recent',
  Playlist: 'Playlist',
  Video: 'Video',
  Stop: 'Stop',
  'Nothing playing. Paste a link below.': 'Nothing dey play. Paste link for down.',
  Playing: 'Dey play',
  'No signal': 'No network',
  'Put the phone away': 'Keep di phone',
};
